export const DotsBrick = () => {
  return (
    <div className='dot-bricks left-[50%] -ml-[3px]'>
      <div className='relative -left-[9999px] top-[4px] h-[5px] w-[5px] animate-dotBricksGray rounded-full shadow-dotBricks' />
    </div>
  );
};
